(() => {
  if (window.__kk) return; window.__kk = 1;
  const ready = (fn) => document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn);
  ready(() => {
    // Before/after slider
    document.querySelectorAll('[data-kk-ba]').forEach((el) => {
      const r = el.querySelector('input');
      const set = (v) => el.style.setProperty('--pos', v + '%');
      r.addEventListener('input', () => set(r.value));
    });
    // Quantity
    document.querySelectorAll('[data-kk-qty]').forEach((el) => {
      const i = el.querySelector('input');
      el.addEventListener('click', (e) => {
        const b = e.target.closest('button'); if (!b) return;
        i.value = Math.min(+i.max || 99, Math.max(1, (+i.value || 1) + +b.dataset.step));
      });
    });
    // Gallery
    document.querySelectorAll('[data-kk-gallery]').forEach((g) => {
      g.addEventListener('click', (e) => {
        const t = e.target.closest('.kk-gallery__thumb'); if (!t) return;
        g.querySelectorAll('.is-active').forEach((n) => n.classList.remove('is-active'));
        t.classList.add('is-active');
        g.querySelector(`.kk-gallery__slide[data-index="${t.dataset.index}"]`).classList.add('is-active');
      });
    });
    // Variant price
    const sel = document.getElementById('kk-variant');
    if (sel) sel.addEventListener('change', () => {
      const p = sel.selectedOptions[0].dataset.price;
      document.querySelectorAll('[data-kk-price]').forEach((n) => (n.textContent = p));
    });
    // Sticky add to cart
    const bar = document.querySelector('[data-kk-sticky]');
    const atc = document.getElementById('kk-atc');
    if (bar && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', String(!show));
        bar.querySelector('button').tabIndex = show ? 0 : -1;
      }).observe(atc);
    }
  });
})();
